import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import useBreakpoints from "../../util/breakpoints";

const Header = ({ color, tag, tagStyle, align, style, children, css }) => {
  const theme = useTheme();

  let tagStyleSet = tagStyle;
  if (tagStyleSet === "") { tagStyleSet = tag; }

  const breakCss = useBreakpoints()({
    fontSize: theme.typography[tagStyleSet].sizes,
    margin: theme.typography[tagStyleSet].margin
  });

  const rootCss = {
    fontFamily: theme.typography[tagStyleSet].fontFamily,
    fontWeight: theme.typography[tagStyleSet].fontWeight,
    letterSpacing: theme.typography[tagStyleSet].letterSpacing,
    color: theme.colors.text[color][theme.variant],
    textAlign: align,
  };

  const Tag = tag;
  return <Tag css={[css, rootCss, breakCss, style]}>{children}</Tag>;
};

Header.defaultProps = {
  tag: "h2",
  tagStyle: "",
  color: "based",
  align: "left",
  style: [],
};

Header.propTypes = {
  tag: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", ""]),
  tagStyle: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", ""]),
  color: PropTypes.oneOf([
    "brand",
    "primary",
    "base",
    "based",
    "secondary",
    "success",
    "error",
    "warning",
    "info",
  ]),
  align: PropTypes.string,
  children: PropTypes.node,
  css: PropTypes.array,

  style: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ])
};

export default Header;
